import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    "data-testid": `transfer-order-list-item-row-${_ctx.transferOrder.orderId}`,
    detail: true,
    button: "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getOrderDetail(_ctx.transferOrder.orderId)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_label, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.transferOrder.orderName) + " ", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.transferOrder.orderExternalId), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.transferOrder.orderId), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_label, {
        class: "ion-text-end",
        slot: "end"
      }, {
        default: _withCtx(() => [
          (_ctx.transferOrder.orderDate)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.getTime(_ctx.transferOrder.orderDate)), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-testid"]))
}